import { JONATHAN_PORTRAIT, ON_SITE_PHOTOS } from "./constants";

export default function MeetJonathan({ c }) {
  return (
    <section id="jonathan" className="py-24 md:py-32 bg-cvc-parchment/50">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-5">
          <div className="relative">
            <div className="absolute -inset-4 bg-cvc-navy/10 rounded-3xl rotate-2" />
            <img
              src={JONATHAN_PORTRAIT}
              alt="Jonathan Johnson"
              className="relative w-full aspect-[4/5] object-cover rounded-2xl shadow-lg"
            />
            <div className="absolute -bottom-5 -right-3 bg-cvc-cream rounded-2xl border border-cvc-border px-5 py-3 shadow-md">
              <p className="font-heading text-cvc-navy text-xl">Jonathan Johnson</p>
              <p className="font-body text-xs uppercase tracking-wider text-cvc-red">Local Scaling-Up Expert</p>
            </div>
          </div>
        </div>
        <div className="lg:col-span-7">
          <p className="text-xs tracking-[0.3em] uppercase font-body font-semibold text-cvc-red">Meet your consultant</p>
          <h2 className="font-heading text-4xl md:text-5xl text-cvc-navy mt-4 leading-tight">
            A local hand on your shoulder — every week or two.
          </h2>
          <p className="font-body text-cvc-ink-soft text-lg mt-6 leading-relaxed">
            {c("jonathan_blurb", "Jonathan Johnson is Cache Valley Consulting's local scaling-up expert. He shows up in person, every week or two, walks your floor, sits at your table, and helps you re-engineer your business one duty at a time — until you can step out of the day-to-day for good.")}
          </p>
          <div className="mt-8 grid sm:grid-cols-2 gap-4">
            <div className="rounded-xl border border-cvc-border bg-white p-5">
              <p className="font-heading text-xl text-cvc-navy">On-site, in person</p>
              <p className="font-body text-sm text-cvc-ink-soft mt-1">Jonathan comes to your business in Logan and surrounding Cache Valley — not a zoom call.</p>
            </div>
            <div className="rounded-xl border border-cvc-border bg-white p-5">
              <p className="font-heading text-xl text-cvc-navy">Regular cadence</p>
              <p className="font-body text-sm text-cvc-ink-soft mt-1">2 or 3 working sessions a month, structured around your bottlenecks and end-progress goals.</p>
            </div>
          </div>

          {/* On-site proof strip — Jonathan inside actual Cache Valley client shops */}
          <div data-testid="on-site-strip" className="mt-7">
            <p className="font-body text-[10px] tracking-[0.3em] uppercase text-cvc-red mb-3">On the floor, in the valley</p>
            <div className="grid grid-cols-4 gap-2">
              {ON_SITE_PHOTOS.slice(0, 4).map((p) => (
                <img
                  key={p.url}
                  src={p.url}
                  alt={p.alt}
                  loading="lazy"
                  className="w-full aspect-square object-cover rounded-lg border border-cvc-border hover:scale-[1.02] transition-transform duration-300"
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
